class TickerBar extends HTMLElement {
  constructor() {
    super();
    this._calculateDuration = this._calculateDuration.bind(this);
    this._resizeObserver = new ResizeObserver(this._calculateDuration);
  }

  connectedCallback() {
    this._resizeObserver.observe(this);
    this._calculateDuration([{
      target: this,
      contentRect: this.getBoundingClientRect()
    }]);
  }

  disconnectedCallback() {
    this._resizeObserver.disconnect();
  }

  _calculateDuration(entries) {
    const scrollingSpeed = parseInt(this.getAttribute("scrolling-speed") || 5), contentWidth = entries[0].contentRect.width, slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);
    this.style.setProperty("--ticker-animation-duration", `${(scrollingSpeed * slowFactor * entries[0].target.querySelector("span").clientWidth / contentWidth).toFixed(3)}s`);
  }
}

if (!window.customElements.get("ticker-bar")) {
  window.customElements.define("ticker-bar", TickerBar);
}